import courierData from "./courierData";

export const getCouriers = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        data: courierData,
        total: courierData.length
      });
    }, 500);
  });
};

export const getCourierById = (id) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(courierData.find((item) => item.id === parseInt(id)));
    }, 300);
  });
};